export enum TypeProductionSiteEnum {
  OFF_SHORE = 'off-shore',
}
